<div [class.dark]="darkBackground">
  @if (section.text_title && section.text_title !== '__EMPTY_TITLE__') {
    <h2
      [style.fontFamily]="
        (section.text_title_typography.font_family || gallery.default_title_typography?.font_family) + ', AkkuratLL'
      "
      [style.color]="section.text_title_typography?.font_color || gallery.default_title_typography?.font_color"
      class="{{ titleFontSize }}"
    >
      {{ section.text_title }}
    </h2>
  }
  @if (section.text_paragraph) {
    <p
      [style.fontFamily]="
        (section.text_paragraph_typography.font_family || gallery.default_paragraph_typography?.font_family) +
        ', AkkuratLL'
      "
      [style.color]="section.text_paragraph_typography?.font_color || gallery.default_paragraph_typography?.font_color"
      class="{{ paragraphFontSize }}"
      [innerHTML]="textParagraph"
    ></p>
  }
</div>
